import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6402 12.7136C21.6402 12.0882 21.5848 11.4944 21.4898 10.9165H12.5439V14.4869H17.666C17.4364 15.6586 16.7635 16.6482 15.766 17.3211V19.6961H18.8219C20.611 18.0415 21.6402 15.6032 21.6402 12.7136Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5439 22.0001C15.1089 22.0001 17.2544 21.1451 18.8219 19.6963L15.766 17.3213C14.911 17.8913 13.8264 18.2397 12.5439 18.2397C10.066 18.2397 7.9681 16.5692 7.21602 14.313H4.06519V16.7592C5.62477 19.8626 8.83102 22.0001 12.5439 22.0001Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.21603 14.3128C7.01811 13.7428 6.91519 13.1332 6.91519 12.4999C6.91519 11.8666 7.02603 11.257 7.21603 10.687V8.24072H4.06519C3.41603 9.52322 3.04395 10.9641 3.04395 12.4999C3.04395 14.0357 3.41603 15.4766 4.06519 16.7591L7.21603 14.3128Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5439 6.76042C13.9452 6.76042 15.196 7.24334 16.1856 8.18542L18.8931 5.47792C17.2544 3.94208 15.1089 3 12.5439 3C8.83102 3 5.62477 5.1375 4.06519 8.24084L7.21602 10.6871C7.9681 8.43084 10.066 6.76042 12.5439 6.76042Z",
			fill: "#EA4335"
		})
	]
});
export default SvgGoogle;
